import { Money } from '@/components/ds'
import { DashboardStats } from '@/interfaces/DashboardStats'
import { cn } from '@/lib/utils'

import { formatPercentChange } from './number-format'

/** Meziroční srovnání vystavených faktur: řádek na rok, pruh podle podílu na maximu a změna proti předchozímu roku. */
export const YearlyGraph = ({ data, limit = 6 }: { data: DashboardStats; limit?: number }) => {
  const currentYear = String(new Date().getFullYear())
  const years = Object.keys(data.yoyIssued).sort()
  const rows = years.map((year, i) => ({
    year,
    value: Number(data.yoyIssued[year].amount),
    currency: data.yoyIssued[year].currency,
    // rozpracovaný letošek neporovnáváme s celým loňským rokem, číslo by klamalo
    // první rok s daty bývá neúplný (registrace v průběhu roku), proto ho nesrovnáváme
    change: i > 1 && year !== currentYear ? formatPercentChange(Number(data.yoyIssued[year].amount), Number(data.yoyIssued[years[i - 1]].amount)) : null,
  }))
  const visible = rows.slice(-limit).reverse()
  const max = Math.max(1, ...visible.map((r) => r.value))

  if (!visible.length) {
    return <p className="py-6 text-sm text-muted-foreground">Zatím žádné vystavené faktury.</p>
  }

  return (
    <ul className="divide-y">
      {visible.map((r) => (
        <li key={r.year} className="py-2.5">
          <div className="flex items-baseline justify-between gap-3 text-sm">
            <span className="tabular">
              {r.year}
              {r.year === currentYear && <span className="ml-1.5 text-xs text-muted-foreground">zatím</span>}
            </span>
            <span className="flex items-baseline gap-2">
              {r.change && (
                <span className={cn('tabular text-xs', r.change.startsWith('-') ? 'text-danger' : 'text-muted-foreground')}>{r.change}</span>
              )}
              <Money amount={r.value} currency={r.currency} size="sm" />
            </span>
          </div>
          <div className="mt-1.5 h-1 overflow-hidden rounded-full bg-muted">
            <div className={cn('h-full rounded-full', r.year === currentYear ? 'bg-chart-2' : 'bg-brand')} style={{ width: `${(r.value / max) * 100}%` }} />
          </div>
        </li>
      ))}
    </ul>
  )
}
